<!-- SPDX-License-Identifier: LicenseRef-MMS-WIRE -->
<!-- Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd -->

<div [ngClass]="{'disabled' : disabled}" tabindex="-1">
  <div class="row dtp-container">
    <label class="row time-traveler-label">
      @if (icons) {
        <div>
          <timezone-selector></timezone-selector>
        </div>
      }
      @if (icons) {
        <div class="text">Time traveler</div>
      }
      <i class="chevron"></i>
    </label>
    @if (dtp) {
      <div class="mobile-container row">
        <div class="time-traveler-in-mobile-container">
          <timezone-selector></timezone-selector>
        </div>
        @if (dateTimePeriodService.show_calendar && calendars && calendars.length > 0) {
          <div class="calendar">
            <label class="text">Calendar</label>
            <mat-select (selectionChange)="changeCalendar()" [(value)]="dtp.calendar" [disabled]="disabled"
              class="calendar-select" matTooltip="Select a calendar / period type."
              panelClass="list-below-select-panel full-height-select-panel" placeholder="Select Calendar"
              >
              @for (calendar of calendars; track calendar) {
                @if (calendar.account_id === appScope.active_account_id || calendar.name === dateTimePeriodService.defaultCalendar) {
                  <mat-option
                    [value]="calendar.name">
                    <span>{{calendar.name | removeUnderscore | upperfirst}}</span>
                    <!--@if (calendar.account_name) { <span>{{calendar.account_name | upperfirst}}</span> }-->
                  </mat-option>
                }
              }
            </mat-select>
          </div>
        }
        @if (dateTimePeriodService.show_timespan && showTimespan !== false) {
          <div class="range">
            @if (icons) {
              <img class="range-icon" src='/static/icons/timespan.png'/>
            }
            <label class="text">Time Span</label>
            <!-- Trigger button for main menu -->
            <button mat-button [matMenuTriggerFor]="mainRangeMenu" [disabled]="disabled"
              class="date-select-button range-select"
              matTooltip="Select a predefined date range.">
              <span>{{dtp.range ? (dtp.range | upperfirst | removeUnderscore) : 'Range'}}</span>
              <span class="button-icon"><mat-icon>arrow_drop_down</mat-icon></span>
            </button>
            <!-- Main Menu -->
            <mat-menu #mainRangeMenu="matMenu" class="nested-range-menu-panel">
              <!-- Loop through main menu options -->
              @for (range of ranges; track range) {
                <!-- Regular options -->
                @if (!(range.is_parent || rangeMenuMap[range.range]?.length) && !range.parent) {
                  <button mat-menu-item (click)="changeRange(range.range)">
                    {{range.range | upperfirst | removeUnderscore}}
                  </button>
                }
                @if (range.is_parent && rangeMenuMap[range.range]?.length) {
                  <button mat-menu-item [matMenuTriggerFor]="getMenu(range.range)">
                    {{range.range | upperfirst | removeUnderscore}}
                  </button>
                }
              }
            </mat-menu>
            <!-- Submenus -->
            <mat-menu #yesterdayByHalfShift="matMenu" class="nested-range-menu-panel">
              <ng-container [ngTemplateOutlet]="subRangeMenus"
              [ngTemplateOutletContext]="{ $implicit: 'yesterday by half shift'}"></ng-container>
            </mat-menu>
            <mat-menu #thisShift="matMenu" class="nested-range-menu-panel">
              <ng-container [ngTemplateOutlet]="subRangeMenus"
              [ngTemplateOutletContext]="{ $implicit: 'this shift'}"></ng-container>
            </mat-menu>
            <mat-menu #week="matMenu" class="nested-range-menu-panel">
              <ng-container [ngTemplateOutlet]="subRangeMenus"
              [ngTemplateOutletContext]="{ $implicit: 'week'}"></ng-container>
            </mat-menu>
            <mat-menu #month="matMenu" class="nested-range-menu-panel">
              <ng-container [ngTemplateOutlet]="subRangeMenus"
              [ngTemplateOutletContext]="{ $implicit: 'month'}"></ng-container>
            </mat-menu>
            <mat-menu #quarter="matMenu" class="nested-range-menu-panel">
              <ng-container [ngTemplateOutlet]="subRangeMenus"
              [ngTemplateOutletContext]="{ $implicit: 'quarter'}"></ng-container>
            </mat-menu>
            <mat-menu #year="matMenu" class="nested-range-menu-panel">
              <ng-container [ngTemplateOutlet]="subRangeMenus"
              [ngTemplateOutletContext]="{ $implicit: 'year'}"></ng-container>
            </mat-menu>
            <ng-template #subRangeMenus let-menuGroup>
              @for (option of rangeMenuMap[menuGroup]; track option) {
                <button mat-menu-item (click)="changeRange(option.range)">
                  {{option.range  | upperfirst | removeUnderscore}}
                </button>
              }
            </ng-template>
          </div>
        }
        @if (dateTimePeriodService.show_timespan && showTimespan !== false && sample_periods) {
          <div class="period">
            <label class="text">By</label>
            <!-- Trigger button for main menu -->
            <button mat-button [matMenuTriggerFor]="mainMenu" class="date-select-button period-select"
              matTooltip="Select the sample period for your date range.">
              <span>{{dtp.sample_period ? (dtp.sample_period.name | upperfirst | removeUnderscore) : 'Sample Period'}}</span>
              <span class="button-icon"><mat-icon>arrow_drop_down</mat-icon></span>
            </button>
            <!-- Main Menu -->
            <mat-menu #mainMenu="matMenu" class="nested-range-menu-panel">
              <!-- Loop through main menu options -->
              @for (sample_period of sample_periods; track sample_period) {
                <!-- Regular options -->
                @if (!sample_period.is_parent && !sample_period.parent) {
                  <button mat-menu-item (click)="selectPeriod(sample_period)">
                    {{sample_period.name | upperfirst | removeUnderscore}}
                  </button>
                }
                @if (sample_period.is_parent && periodMenuMap[sample_period.name]?.length) {
                  <button mat-menu-item [matMenuTriggerFor]="getMenu(sample_period.name)">
                    {{sample_period.name | upperfirst | removeUnderscore}}
                  </button>
                }
              }
            </mat-menu>
            <!-- Submenus -->
            <mat-menu #shift="matMenu" class="nested-range-menu-panel">
              <ng-container [ngTemplateOutlet]="subMenus"
              [ngTemplateOutletContext]="{ $implicit: 'shift'}"></ng-container>
            </mat-menu>
            <ng-template #subMenus let-menuGroup>
              @for (option of periodMenuMap[menuGroup]; track option) {
                <button mat-menu-item (click)="selectPeriod(option)">
                  {{option.name  | upperfirst | removeUnderscore}}
                </button>
              }
            </ng-template>
          </div>
        }
      </div>
      <div class="datepicker row">
        <div class="start-date">
          <label class="text start-date">Start</label>
          @if (dtp_ready) {
            <div class="row date-part">
              <input (dateChange)="changeDate($event)"
                (focusout)="checkDate()"
                [matDatepicker]="startPicker"
                [value]="dtp.start"
                tabindex="-1"
                class="datetime"
                name="start"
                matTooltip="Type or click the calendar to select a custom start date.">
              <mat-datepicker-toggle [for]="startPicker" matSuffix>
                <span class="icon-arrow-down" matDatepickerToggleIcon></span>
              </mat-datepicker-toggle>
              <mat-datepicker #startPicker (opened)="streamOpened('start')"
                (monthSelected)="streamOpened('start')"
                [dateClass]="dateClass"
              panelClass="start-picker wire-time-traveler"></mat-datepicker>
            </div>
          }
          @if (dateTimePeriodService.show_time && showTime !== false) {
            <div class="row center">
              <input (change)="changeTime($event)"
                (focusout)="checkDate()"
                [value]="dtp.start | stringDate: {time_only:true}"
                tabindex="-1"
                class="datetime time"
                name="start_time"
                matTooltip="Click the clock to select a custom start time."
                type="time"
                lang="en-GB"
                >
            </div>
          }
        </div>
        <div class="end-date">
          <label class="text end-date">End</label>
          <label class="text end-date-min">To</label>
          @if (dtp_ready) {
            <div class="row date-part">
              <input (dateChange)="changeDate($event)"
                (focusout)="checkDate()"
                [matDatepicker]="endPicker"
                [value]="dtp.end"
                tabindex="-1"
                class="datetime"
                name="end"
                matTooltip="Type or click the calendar to select a custom end date.">
              <mat-datepicker-toggle [for]="endPicker" matSuffix>
                <span class="icon-arrow-down" matDatepickerToggleIcon></span>
              </mat-datepicker-toggle>
              <mat-datepicker #endPicker (opened)="streamOpened('end')"
                (monthSelected)="streamOpened('end')"
                [dateClass]="dateClass"
              panelClass="end-picker wire-time-traveler"></mat-datepicker>
            </div>
          }
          @if (dateTimePeriodService.show_time && showTime !== false) {
            <div class="row center">
              <input (change)="changeTime($event)"
                (focusout)="checkDate()"
                [value]="dtp.end | stringDate: {time_only:true}"
                tabindex="-1"
                class="datetime time"
                name="end_time"
                matTooltip="Click the clock to select a custom end time."
                type='time'
                lang="en-GB"
                >
            </div>
          }
        </div>
      </div>
      <div class="datetime-pager hide-xs">
        <i (click)="travel('backwards')" class="fa fa-arrow-circle-o-left"
        matTooltip="Travel one sample period backwards."></i>
        <i (click)="travel('forward')" class="fa fa-arrow-circle-o-right"
        matTooltip="Travel one sample period forwards."></i>
      </div>
      <div [ngClass]="{'dtp-immutable': immutable}" class="dtp-refresh">
        <i (click)="refreshDTP(immutable)" class="fa fa-refresh"></i>
      </div>
      @if (isOnPageView && isPageCalculationUpdateEnabled) {
        <div class="dtp-update-calcs"
          [ngClass]="{'dtp-disabled': isUpdatingCalculations}">
          <i (click)="updatePageCalculations()" class="fa fa-calculator"
          [matTooltip]="isUpdatingCalculations ? 'Please wait...' : 'Update all series calculations'"></i>
        </div>
      }
    }
  </div>
</div>
